<script>
  export let title;
  export let description;
  export let onClickSubmit = () => {};
  export let submitLabel = 'Submit';
  export let onClickCancel;
  export let cancelLabel = 'Cancel';
</script>

<div class="fixed flex top-0 w-full h-full z-30 justify-center items-center">
  <div class="absolute bg-black opacity-30 w-full h-full" />
  <div class="rounded-xl border border-gray-100 bg-white p-4 shadow-xl z-30">
    <div class="flex items-start gap-4">
      <div class="flex-1">
        <strong class="block font-medium text-slate-900"> {title} </strong>

        <p class="mt-1 text-sm text-slate-700">{description}</p>

        <div class="mt-4 flex gap-2">
          <button
            class="inline-flex items-center gap-2 rounded-xl bg-indigo-600 px-4 py-2 text-white hover:bg-indigo-700"
            on:click={onClickSubmit}
          >
            <span class="text-sm"> {submitLabel} </span>
          </button>

          {#if onClickCancel}
            <button
              class="block rounded-xl px-4 py-2 text-slate-700 transition hover:bg-gray-100"
              on:click={onClickCancel}
            >
              <span class="text-sm">{cancelLabel}</span>
            </button>
          {/if}
        </div>
      </div>

      <button class="text-slate-600 transition hover:text-slate-600" on:click={onClickCancel}>
        <span class="sr-only">Dismiss popup</span>

        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="h-6 w-6"
        >
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  </div>
</div>
